/**
 * The host adapter for the `action-confirmation` client-side entity (ADR-029
 * §4). The executor (in `@fias/client-entities`) runs with only
 * `{ userId, archeId }`; the plugin renderer that mounted an arche registers
 * here the function that draws ITS confirm sheet, and the executor reaches it
 * by arche id. An arche with no mounted renderer answers CONFIRM_UNAVAILABLE.
 */

import type { ActionConfirmationHost, ActionConfirmationResult } from '@fias/client-entities';

type SheetHandler = (pendingActionId: string) => Promise<ActionConfirmationResult>;

const handlers = new Map<string, SheetHandler>();

/** Called by the plugin renderer on mount; returns the unregister function. */
export function registerConfirmSheet(archeId: string, handler: SheetHandler): () => void {
  handlers.set(archeId, handler);
  return () => {
    if (handlers.get(archeId) === handler) handlers.delete(archeId);
  };
}

export const actionConfirmationHost: ActionConfirmationHost = {
  async showConfirmSheet({ archeId, pendingActionId }) {
    const handler = handlers.get(archeId);
    if (!handler) {
      return {
        error: {
          code: 'CONFIRM_UNAVAILABLE',
          message: 'Approving actions is not available here',
        },
      };
    }
    return handler(pendingActionId);
  },
};
